import React from 'react';
import { useRecoilValue } from 'recoil';

import { classPlaylistContent } from 'atoms/classPlaylistContent';
import { PlaylistMarkdownPreview } from 'features/classCreation';
import styles from './PlaylistMarkdownRenderer.module.scss';

function PlaylistMarkdownRenderer() {
  const content = useRecoilValue(classPlaylistContent);

  return (
    <PlaylistMarkdownPreview
      mdString={content}
      className={styles.root}
    />
  );
}

export default PlaylistMarkdownRenderer;
